<div *apSecure='[Permissions.ACCESS_ALL_DOC_PROOF]' class='form-horizontal form-label-left docproof-section'>
  <span class='section panel-role-title'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.REQUEST_PROFILE_DOCUMENTARY.TITLE' | translate }}</span>
  @if (documentaryProofs?.length > 0) {
    <div class='row'>
      <!-- DOCPROOF LIST -->
      <div class='col-sm-3 col-md-3 col-xs-3'>
        @for (documentary of documentaryProofs; track documentary; let index = $index) {
          <ap-documentary-proof-card [index]='index' [documentaryProof]='documentary' [documentSelected]='documentaryProofFileSelected' (select)='selectFile($event)' (onChangeDocument)='updateEditValidateButton($event)'></ap-documentary-proof-card>
        }
      </div>
      <!-- VISUALIZER -->
      <div class='col-sm-9 col-md-9 col-xs-9'>
        @if (documentLoaded) {
          @if (hasDocument() && documentaryProofFileSelected && containsData) {
            <div class='row'>
              @if (index != null && indexFile != null) {
                <h2 class='col-sm-6 col-md-6 col-xs-6'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.VISUALIZER.TITLE' | translate: {indexFile: indexFile+1, index: index+1} }}</h2>
              }
            </div>
            @if (documentPhoto?.extension === 'pdf') {
              <ngx-extended-pdf-viewer
                [base64Src]='documentPhoto.imageData'
                [height]='height'
                useBrowserLocale='true'
                [showDrawEditor]='false'
                [showTextEditor]='false'
                [showOpenFileButton]='false'
                [showStampEditor]='false'
                [showSecondaryToolbarButton]='false'
                [filenameForDownload]="documentPhoto.imageName + '.' + documentPhoto.extension"
                (pagesLoaded)='onPagesLoaded($event)'>
              </ngx-extended-pdf-viewer>
            } @else {
              @if (src) {
                <ap-image-viewer [src]='src' [alt]='documentPhoto.imageName' [extension]='documentPhoto.extension'></ap-image-viewer>
              }
            }
          }
          @if (!documentaryProofFileSelected && hasDocument()) {
            <ap-jumbotron [icon]="'fa-inbox'">{{ 'COMMON.LABELS.SELECT_FILE' | translate }}</ap-jumbotron>
          }
          @if (documentaryProofFileSelected && !containsData) {
            <ap-jumbotron [icon]="'fa-inbox'">{{ 'COMMON.LABELS.NO_DATA' | translate }}</ap-jumbotron>
          }
        } @else {
          <ap-jumbotron [icon]="'fa-spinner fa-spin'">{{ 'COMMON.LABELS.LOADING' | translate }}</ap-jumbotron>
        }
      </div>
    </div>
  } @else {
    <ap-jumbotron [icon]="'fa-inbox'">{{ 'COMMON.LABELS.NO_DOCUMENT_FILE' | translate }}</ap-jumbotron>
  }
</div>
